import request from './axios'
import urls from "./urls"
import user from './user'
export default {

    // 任务列表
    getUserMenu() {
      return request.get(urls.userMenu)
    },
    getCategoryList() {
        return request.get(urls.getCategoryList)
    },
    getDocumentList(data) {
        return request.post(urls.getDocumentList, data)
    },
    getCityList() {
        return request.get(urls.getCityList)
    },
    editBusiness(data) {
        return request.post(urls.editBusiness, data)
    },
    createBusiness(data) {
        return request.post(urls.createBusiness, data)
    },
    createDocument(data) {
        return request.post(urls.createDocument, data)
    },
    createProject(id, data) {
        return request.post(urls.createProject(id), data)
    },
    getBusinessInfo(id) {
        return request.get(urls.getBusinessInfo(id))
    },
    //我的商机
    getAllcomList(userId, page) {
        return request.get(urls.getAllcomList(userId, page))
    },
    getAllcom(page, search, startTime, endTime) {
        return request.get(urls.getAllcom(page, search, startTime, endTime))
    },
    getAllcommore(search, startTime, endTime) {
        return request.get(urls.getAllcommore(search, startTime, endTime))
    },
    getBusinessTypeList() {
        return request.get(urls.getBusinessTypeList)
    },
    getElevatorSeriesList() {
        return request.get(urls.getElevatorSeriesList)
    },
    getElevatorTypeList(data) {
        return request.post(urls.getElevatorTypeList, data)
    },
    getDocumentTaskList(id) {
        return request.get(urls.getDocumentTaskList(id))
    },
    getSceneList() {
        return request.get(urls.getSceneList)
    },
    getSceneDocList(id) {
        return request.get(urls.getSecenDocList(id))
    },
    //没有他了
    // getRequiredSource(id) {
    //     return request.get(urls.getRequiredSource(id))
    // },
    getTaskSelectSourceList(id) {
        return request.get(urls.getTaskSelectSourceList(id))
    },

    saveProjectIntro(data) {
      return request.post(urls.saveProjectIntro,data)
    },
    saveCustomPage(data) {
      return request.post(urls.saveCustomPage,data)
    },
    getPreviewImgList(data) {
        return request.post(urls.getPreviewImgList, data)
    },
    // getPreviewImgList(id) {
    //     return request.get(urls.getPreviewImgList(id))
    // },
    getSelectedModules(id) {
        return request.get(urls.getSelectedModules(id))
    },
    getSourceList(data) {
        return request.post(urls.getSourceList, data)
    },
    saveTask(data) {
        return request.post(urls.saveTask, data)
    },
    getCoverList(fileType,docId) {
        return request.get(urls.getCoverList(fileType,docId))
    },
    publishDocument(data) {
        return request.post(urls.publishDocument, data)
    },
    getPreview(data) {
        return request.post(urls.getPreview, data)
    },
    preview(data) {
      return request.post(urls.preview, data)
    },
    getRecommendTags(data) {
        return request.post(urls.getRecommendTags, data)
    },
    copyTask(taskId) {
        return request.get(urls.copyTask(taskId))
    },
    getTaskInfo(taskId) {
        return request.get(urls.taskInfo(taskId))
    },
    // downloadTaskFile(taskId) {
    //     return request.get(urls.downloadTaskFile(taskId), { responseType: 'arraybuffer' })
    // },
    downloadTaskFile(taskId) {
        return request.get(urls.downloadTaskFile(taskId))
    },
    documentUpload(data) {
        return request.post(urls.documentUpload, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
    },
    taskPreview(taskId) {
        return request.get(urls.taskPreview(taskId))
    },
    getLogin(data) {
        return request.post(user.getLogin, data)
    },
    // 获取图片信息
    getInfo(token) {
        return request.get(user.getInfo, { headers: { token } })
    },
    // 修改密码
    getUpdata(data) {
        return request.put(user.getUpdata, data)
    },
    // 退出登录
    getOut() {
        return request.get(user.getOut)
    },
    saveKeyword(data) {
        return request.post(urls.saveKeyword, data)
    },
    QinwenLogin(state) {
        return request.get(user.QinwenLogin(state))
    },
    //PPT图片模板
    pptImg(type,fileType) {
        return request.get(urls.pptImg(type,fileType))
    },
    //图片树
    imgTree() {
        return request.get(urls.imgTree)
    },
    //我的项目档案
    myList(id) {
        return request.get(urls.myList(id))
    },
    //官方档案
    offList(bid) {
        return request.get(urls.offList(bid))
    },
    //上传档案
    createOrUpdate(data) {
        return request.post(urls.createOrUpdate, data)
    },
    //上传文件
    uploadFiles(data) {
        return request.post(urls.uploadFiles, data)
    },
    //档案信息
    getProject(bid) {
        return request.get(urls.getProject(bid))
    },
    assignmentList(pageNum, pageSize) {
        return request.get(urls.assignmentList(pageNum, pageSize))
    },
    //业绩清单
    performanceList(params) {
        return request.get(urls.performanceList, params)
    },
    exportList(fileName, ids) {
        return request.get(urls.exportList(fileName, ids), { responseType: 'blob', headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
    },
    // 任务列表
    taskList(pageNum, pageSize) {
        return request.get(urls.taskList(pageNum, pageSize))
    },
    // 项目列表
    projectList(pageNum, pageSize) {
        return request.get(urls.projectList(pageNum, pageSize))
    },
    //关联项目
    getRelevance(data) {
        return request.post(urls.getRelevance, data)
    },
    //任务列表的城建项目
    getCreateProject(projectId) {
        return request.post(urls.getCreateProject(projectId))
    },
    //获取自定义选择图片tags
    getCustomPageImageTags(moduleId, taskId) {
        return request.get(urls.getCustomImageTags(moduleId, taskId))
    },
    //获取自定义选择图片列表
    getCustomPageImages(data) {
        return request.post(urls.getCustomImages, data)
    },
    uploadProjectImage(data) {
        return request.post(urls.uploadProjectImage, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    //修改项目官方名字
    authorityName(data){
        return request.put(urls.authorityName, data)
    },
    //项目id
    projectId(id) {
      return request.get(urls.projectId(id))
    },
    getArea() {
      return request.get(urls.getArea)
    },
    uploadDirectoryWord(data,documentId) {
        return request.post(urls.uploadDirectoryWord+'/'+documentId, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
    },
    //删除素材
    deteleType(id, type, bid) {
      return request.post(urls.deteleTypeData(id, type, bid))
    },
    checkCertificateExpired(id){
      return request.get(urls.certificateExpired(id))
    }
}
